// src/components/approval-line/computeDefaultApprovalLine.js
// ✅ 결재선 자동 생성 규칙 — 기존에는 ApprovalLineModal.jsx를 열 때만(내부 useEffect)
// 실행되던 하드코딩 로직이었다. 작성 페이지 진입 즉시(ApprovalLine.jsx 마운트 시)
// 결재선을 자동 표시하려면 모달을 열지 않고도 호출할 수 있어야 해서 공용 함수로
// 추출 — ApprovalLine.jsx(자동 표시)와 ApprovalLineModal.jsx(수정 시 초기값 폴백)가
// 공유한다.
import api from "../../api";
import { RESOLUTION_DOCUMENT_TYPES } from "../../utils/resolutionDraft";
import { isActiveStaff } from "../../utils/contractEnded";

// ✅ 문서종류별 규칙: 기안(expense_draft/income_draft)은 합의(나주영) 포함, 결의
// (expense_resolution/income_resolution)는 합의 제외. 작성자 본인이 이미 기안자로
// 들어가므로, 고정 결재자(윤길상/서복성/나주영) 중 작성자와 같은 사람은 중복으로
// 넣지 않는다(예: 작성자가 팀장이면 팀장(기안)→대표이사(결재)만 남음).
export async function computeDefaultApprovalLine(documentType) {
  const userRes = await api.get("/mypage/");
  const currentUserName = userRes.data?.name || userRes.data?.display_name;

  const { data } = await api.get("/staff-contacts/");

  // ⚠️ 계약종료자는 기본 결재선에 넣지 않는다(서버 판정 is_contract_ended).
  // 서복성(대표이사)은 2026-08-31 퇴임 — 이 검사 전엔 이름이 하드코딩돼 있어 퇴임 후에도
  // 새 기안마다 결재선에 들어갔다(9/1 이후 20건). 작성자 본인 조회에는 적용하지 않는다.
  const findUser = (name, { activeOnly = true } = {}) => {
    const found = data.find((item) => item.name === name && (!activeOnly || isActiveStaff(item)));
    return found
      ? { id: found.user_id || found.id, name: found.name, position: found.position || "직원" }
      : null;
  };

  const currentUserInfo = findUser(currentUserName, { activeOnly: false });
  if (!currentUserInfo) return [];

  const yoon = findUser("윤길상");
  const seo = findUser("서복성");
  const na = findUser("나주영");
  const isResolution = RESOLUTION_DOCUMENT_TYPES.includes(documentType);

  return [
    { ...currentUserInfo, status: "기안" },
    ...(yoon && yoon.id !== currentUserInfo.id ? [{ ...yoon, status: "결재" }] : []),
    ...(seo && seo.id !== currentUserInfo.id ? [{ ...seo, status: "결재" }] : []),
    // ✅ 지출결의/수입결의는 합의자를 자동으로 넣지 않는다(수동 추가는 막지 않음 —
    // 이 목록은 자동 기본값일 뿐, 모달에서 얼마든지 추가할 수 있다)
    ...(!isResolution && na && na.id !== currentUserInfo.id ? [{ ...na, status: "합의" }] : []),
  ];
}
